var React = require('react');

function SortIdleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m137.4 9.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-256-.1c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z","fill":"#ccc"}));
}

SortIdleInline.defaultProps = {"height":"448","viewBox":"0 0 320 448","width":"320"};

module.exports = SortIdleInline;

SortIdleInline.default = SortIdleInline;
